module.exports = __webpack_public_path__ + "img/2.e795e66e.png";